var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDhedgeLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 464,
    height: 87,
    viewBox: "0 0 464 87",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.6001 81.1114L53.1836 73.5414V29.9752L67.6001 36.8331V81.1114Z",
    fill: "#00A0D0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 86.9486L14.4562 80.4336V43.1635L0 50.0214V86.9486Z",
    fill: "#00A0D0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4185 75.546L41.2215 69.635V0.433472L26.4185 6.94848V75.546Z",
    fill: "#00A0D0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M160.093 80.3097H145.555V6.785H160.093V80.3097Z",
    fill: "#00A0D0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M116.1 80.4441V75.3851C112.369 79.5157 108.533 81.064 102.729 81.064C97.3387 81.064 92.5703 79.4128 89.5652 76.2107C84.381 71.0488 83.968 62.5793 83.968 53.4926C83.968 44.5087 84.381 36.0418 89.5652 30.8773C92.5703 27.6778 97.2434 26.024 102.626 26.024C108.12 26.024 112.158 27.3666 115.79 31.3943V6.91946H129.264V80.4441H116.1ZM106.568 38.1071C98.5884 38.1071 97.4472 44.82 97.4472 53.4926C97.4472 62.1652 98.5884 68.9835 106.568 68.9835C114.548 68.9835 115.796 62.1678 115.796 53.4926C115.796 44.8173 114.546 38.1071 106.563 38.1071H106.568Z",
    fill: "#00A0D0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M184.823 80.4442V49.6732H159.842V80.4442H145.433V6.91946H159.842V36.9703H184.823V6.91946H199.231V80.4442H184.823Z",
    fill: "#00A0D0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M216.438 80.4442V6.91946H265.052V19.7253H230.844V36.9703H259.969V49.7761H230.844V67.641H265.052V80.4442H216.438Z",
    fill: "#00A0D0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M328.074 69.7063C322.779 77.1392 315.842 80.4442 305.786 80.4442H279.148V6.91946H305.786C315.847 6.91946 322.787 10.2244 328.074 17.66C332.53 24.0616 332.737 31.3943 332.737 43.6831C332.737 55.972 332.53 63.302 328.074 69.7063ZM315.336 24.27C312.953 21.2736 309.323 19.7253 304.558 19.7253H293.57V67.641H304.558C309.323 67.641 312.953 66.09 315.336 63.0963C318.031 59.8942 318.341 55.2493 318.341 43.6831C318.341 32.117 318.018 27.4694 315.336 24.27Z",
    fill: "#00A0D0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M400.008 50.2852C400.008 60.9229 398.35 67.2216 392.96 72.7053C386.74 79.2098 380.002 81.0693 372.125 81.0693C363.73 81.0693 357.51 78.2813 352.432 73.3252C345.072 65.9925 344.968 57.6285 344.968 43.6885C344.968 29.7484 345.072 21.3818 352.432 14.0517C357.51 9.09559 363.73 6.30759 372.125 6.30759C389.229 6.30759 397.935 17.5625 399.905 29.8513H385.393C383.735 22.7296 379.277 19.1108 372.125 19.1108C368.082 19.1108 365.077 20.6591 362.901 23.0356C360.102 26.0293 359.377 29.6297 359.377 43.6885C359.377 57.6285 360.102 61.3476 362.901 64.4442C365.077 66.8181 368.082 68.2635 372.125 68.2635C376.581 68.2635 380.002 66.7152 382.388 64.1329C384.77 61.3476 385.705 58.1455 385.705 54.3235V51.6331H372.125V39.5526H400.008V50.2852Z",
    fill: "#00A0D0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M414.727 80.4442V6.91946H463.34V19.7253H429.135V36.9703H458.26V49.7761H429.135V67.641H463.34V80.4442H414.727Z",
    fill: "#00A0D0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDhedgeLogo);
export default __webpack_public_path__ + "static/media/dhedge-logo.f9b152a71c1477ba4fce1358b5991b1f.svg";
export { ForwardRef as ReactComponent };